// Library Import
import { configureStore } from "@reduxjs/toolkit";

// Local Imports
import { userSlice } from "@slices/userSlice";
import { adminSlice } from "./slices/adminSlice";

export const store = configureStore({
  reducer: {
    stateUserReducer: userSlice.reducer,
    stateAdminReducer: adminSlice.reducer,
  },
});

export default store;
